import React, { useEffect ,useState} from "react";
import {Empty,Button, Pagination,Badge } from "antd";
import { useNavigate } from "react-router-dom";
import useStatsStore from "../../../store/stats.store";

import TableDashBoard from "../../TableDashBoard";

import "../teamAssignment.scss";
import Filter from "../../filter";

export default function TeamAssignmentInterviewScheduling({currentView,cb}) {

  const {teamsDashConsolidatedStatsInterviewScheduling,getTeamsDashBoardConsolidatedStatsInterviewScheduling,teamsDashConsolidatedStatsInterviewSchedulingCount} = useStatsStore();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
   const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };  

  useEffect(() => {
    //getAllJds();
  }, []);

  const resumeSchedulingList = [
    "Sr. No.",
    "Client",
    "TA",
    "Job Title",
    "SPOC",
    "Assigned To",
    "YTBS",
    "Scheduled",
    "YTBRS",
    "Rescheduled",
  ];    


  const resumeSchedulingData = teamsDashConsolidatedStatsInterviewScheduling?.scheduling?.map((sch, idx) => {
    return {
      id: idx + 1 + (pageSize *(currentPage-1)),    
      client_name: sch?.client,
      ta_name: sch?.ta,
      title: '['+sch?.qhcompanyjid+'] '+sch?.title,
      SPOC: sch?.spoc,
      assigned_to: sch?.assignedto,
      numInterviewYTBScheduled: sch?.numinterviewytbscheduled===0?"-":sch?.numinterviewytbscheduled,
      numInterviewScheduled: sch?.numinterviewscheduled===0?"-":sch?.numinterviewscheduled,
      numInterviewTBReScheduled: sch?.numinterviewtbrescheduled===0?"-":sch?.numinterviewtbrescheduled,
      numInterviewRescheduled: sch?.numinterviewrescheduled===0?"-":sch?.numinterviewrescheduled,
    };
  }); 

  return (
    <div className="teamAssignmentPages-wrapper">
      <Filter
        filtername = {"getTeamsDashBoardFilter"}
        initDuration={"24"}
        initPrio={"All"}
        initJDStatus={"Active"}   
        initClient={"All"}            
        enableDuration
        enablePriority
        enableJdStatus
        enableCustomers   
        enableTAs    
        handleFilter={cb}
        pageNo={currentPage}
        pageSize={pageSize}
        pageHandler = {setCurrentPage}                
      />      
      <div></div>

      {teamsDashConsolidatedStatsInterviewScheduling ? (
        <>        
           {currentView==="Interview Scheduling/Rescheduling"?
             <>
              <TableDashBoard
                isClickable={true}
                isJDPage={true}
                titleList={resumeSchedulingList}
                data={resumeSchedulingData}
              />             
             </>:<></>
            }                                     
        </>
        
      ) : (
        <Empty style={{ margin: "60px" }} />
      )}

       <Pagination
              style={{ marginTop: "4px",  float: "inline-end" }}
              current={currentPage}
              pageSize={pageSize}
              total={teamsDashConsolidatedStatsInterviewSchedulingCount}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
                
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
        />            
    </div>
  );
}
